import { Controller } from "@hotwired/stimulus";

// Spelled out: a name built from the value is invisible to the CSS build and to
// bin/guardrails-report. misc and vehicle have no fields of their own.
const ENABLED_CLASSES = {
	weapon: "odo-inventory__weapon-enabled",
	armor: "odo-inventory__armor-enabled",
	shield: "odo-inventory__shield-enabled",
	container: "odo-inventory__container-enabled",
};

// Connects to data-controller="equipment"
export default class extends Controller {
	static targets = ["select"];

	connect() {
		for (const target of this.selectTargets) {
			if (!target.checked) {
				continue;
			}

			this.change(target);
		}
	}

	change(target) {
		this.element.classList.remove(...Object.values(ENABLED_CLASSES));
		const enabled = ENABLED_CLASSES[target.value];
		if (enabled) this.element.classList.add(enabled);
	}

	update(event) {
		const concept = event.currentTarget.dataset.concept;
		for (const target of this.selectTargets) {
			if (target.dataset.concept !== concept) {
				continue;
			}

			this.change(target);
			target.checked = true;
		}
	}
}
